import * as React from 'react';
import Base from 'src/Checkbox/Base';

type Props = {
  value: boolean;
  onChange: (value: true | false) => void;
  onShiftClick?: () => void;
};

const Checkbox = (props: Props) => {
  const {value, onChange, onShiftClick} = props;
  const handleClick = () => onChange(!value);
  return (
    <Base
      value={value ? 'check' : 'empty'}
      onClick={handleClick}
      onShiftClick={onShiftClick}
    />
  );
};

export default Checkbox;
